import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";

export type NavigationItemsProps = {
  title: string;
  route: string;
  icon: string;
};

const NavigationItem = (props: NavigationItemsProps) => {
  const location = useLocation();

  const isActive = () => {
    const targetLocations = props.route.split("/");
    const currentLocations = location.pathname.split("/");

    if (targetLocations[1] === currentLocations[1]) return true;
    return false;
  };

  return (
    <NavigationItemWrapper className={isActive() ? "active" : ""}>
      <Link to={props.route}>
        <i className={props.icon}></i>
        <span>{props.title}</span>
      </Link>
    </NavigationItemWrapper>
  );
};

export default NavigationItem;

const NavigationItemWrapper = styled.li`
  i {
    margin-right: 10px !important;
  }
`;
